/**
 * Mock data generation for testing the graph without API calls.
 * Usage: type "mock N" in the custom list input (e.g. "mock 15").
 */

const POSSIBLE_TAGS = [
    'rock', 'pop', 'electronic', 'indie', 'alternative', 'experimental', 'jazz', 'hip hop',
    'ambient', 'classical', 'folk', 'blues', 'metal', 'punk', 'reggae', 'funk',
    'psychedelic', 'progressive', 'synthwave', 'post-rock', 'shoegaze', 'dream pop',
    'garage rock', 'new wave', 'art rock', 'krautrock', 'noise', 'drone'
];

const generateMockTags = () => {
    const numTags = Math.floor(Math.random() * 5) + 3;
    const shuffled = [...POSSIBLE_TAGS].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, numTags);
};

export const generateMockMusician = (id) => {
    return { id, tags: generateMockTags() };
};

export const generateMockSimilarMusicians = (sourceMusician, count) => {
    const similar = [];
    for (let i = 1; i <= count; i++) {
        similar.push({
            name: `${sourceMusician}_similar${i}`,
            match: (Math.random() * 0.5 + 0.5).toFixed(3)
        });
    }
    return similar;
};

export const isMockData = (musicians) => {
    return musicians.length === 1 && musicians[0].startsWith('__MOCK_DATA__');
};

export const extractMockNodeCount = (mockString) => {
    const match = mockString.match(/^__MOCK_DATA__(\d+)$/);
    return match ? parseInt(match[1]) : 0;
};
